var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__linear-gradient",
    x1: 1.101,
    x2: 0.16,
    y1: -0.11,
    y2: 1.053,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#072340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2065a8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Elipse_227",
    cx: 40.5,
    cy: 40.5,
    r: 40.5,
    fill: "#00c4ff",
    stroke: "#053462",
    strokeWidth: "2px",
    "data-name": "Elipse 227"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__user",
    transform: "translate(-290 -56) translate(290 56)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Elipse_15",
    cx: 40.5,
    cy: 40.5,
    r: 40.5,
    fill: "#00c4ff",
    "data-name": "Elipse 15"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Grupo_de_m\\xE1scara_14",
    clipPath: "url(#prefix__clip-path)",
    "data-name": "Grupo de m\\xE1scara 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Uni\\xE3o_3",
    fill: "url(#prefix__linear-gradient)",
    d: "M.837 46.464L0 44.985l1.121-1.276a16.534 16.534 0 0 1 12.405-5.624h28.393a16.538 16.538 0 0 1 12.407 5.624l1.121 1.275-.837 1.48a30.831 30.831 0 0 1-53.772 0zm10.324-29.8a16.563 16.563 0 1 1 16.562 16.661 16.612 16.612 0 0 1-16.562-16.663z",
    "data-name": "Uni\\xE3o 3",
    transform: "translate(12.777 20.737)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Elipse_228",
    fill: "none",
    stroke: "#053462",
    strokeWidth: "2px",
    "data-name": "Elipse 228"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 40.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 39.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.373dc1542860ae1a55ba1776e789c862.svg";
export { ForwardRef as ReactComponent };